<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code" :flex="false" :fixable="false">
            <ot-row :gutter="20">
                <ot-col :span="6"><div class="grid-content bg-purple"></div></ot-col>
                <ot-col :span="6"><div class="grid-content bg-purple"></div></ot-col>
                <ot-col :span="6"><div class="grid-content bg-purple"></div></ot-col>
                <ot-col :span="6"><div class="grid-content bg-purple"></div></ot-col>
            </ot-row>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%20%3Acode%3D%22code%22%20%3Aflex%3D%22false%22%20%3Afixable%3D%22false%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-row%20%3Agutter%3D%2220%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-col%20%3Aspan%3D%226%22%3E%3Cdiv%20class%3D%22grid-content%20bg-purple%22%3E%3C%2Fdiv%3E%3C%2Fot-col%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-col%20%3Aspan%3D%226%22%3E%3Cdiv%20class%3D%22grid-content%20bg-purple%22%3E%3C%2Fdiv%3E%3C%2Fot-col%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-col%20%3Aspan%3D%226%22%3E%3Cdiv%20class%3D%22grid-content%20bg-purple%22%3E%3C%2Fdiv%3E%3C%2Fot-col%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-col%20%3Aspan%3D%226%22%3E%3Cdiv%20class%3D%22grid-content%20bg-purple%22%3E%3C%2Fdiv%3E%3C%2Fot-col%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-row%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E%0A%0A%3Cstyle%20lang%3D%22scss%22%20scoped%3E%0A.ot-row%20%7B%0A%20%20margin-bottom%3A%2020px%3B%0A%20%20%26%3Alast-child%20%7B%0A%20%20%20%20margin-bottom%3A%200%3B%0A%20%20%7D%0A%7D%0A.ot-col%20%7B%0A%20%20border-radius%3A%204px%3B%0A%7D%0A.bg-purple-dark%20%7B%0A%20%20background%3A%20%2399a9bf%3B%0A%7D%0A.bg-purple%20%7B%0A%20%20background%3A%20%23d3dce6%3B%0A%7D%0A.bg-purple-light%20%7B%0A%20%20background%3A%20%23e5e9f2%3B%0A%7D%0A.grid-content%20%7B%0A%20%20border-radius%3A%204px%3B%0A%20%20min-height%3A%2036px%3B%0A%7D%0A.row-bg%20%7B%0A%20%20padding%3A%2010px%200%3B%0A%20%20background-color%3A%20%23f9fafc%3B%0A%7D%0A%3C%2Fstyle%3E`),
        };
    },
};
</script>

<style lang="scss" scoped>
.ot-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.ot-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
